export const getShopByLicencePlate = state => state.shopByLicencePlate
export const getStates = state => getShopByLicencePlate(state).states
